<template>
    <div class="track-rocl" v-loading="loading">
        <div v-if="logisTraceData.message != null">
            <span>{{logisTraceData.message}}</span>
        </div>
        <div class="track-list">
            <ul>
                <li class="afterdate" :class="{'first' : index == 0}" v-for="(logisTrace, index) in logisTraceData.traces">
                    <i class="node-icon">•</i>
                    <span class="date">{{logisTrace.time}}</span>
                    <!--<span class="time">11:17:31</span>-->
                    <span class="txt">{{logisTrace.name}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import logisApi from '../../api/logis'

    export default {
        name: 'swb-logis-trace-info',
        desc: '物流信息',
        props: ['logisExpNo', 'logisComCode'],
        data: function () {
            return {
                logisTraceData: {},
                loading: true,
                logisTraceList: [
                    /*{
                     "name": "[金华市] [东阳十里头]的秦帅已收件 电话:13868967623",
                     "time": "2017-06-14 19:29:08"
                     },
                     {
                     "name": "[金华市] 快件离开 [东阳十里头]已发往[北京]",
                     "time": "2017-06-14 20:06:37"
                     },
                     {
                     "name": "[金华市] 快件到达 [金华中转部]",
                     "time": "2017-06-14 22:47:06"
                     },
                     {
                     "name": "[金华市] 快件离开 [金华中转部]已发往[北京]",
                     "time": "2017-06-14 22:48:45"
                     },
                     {
                     "name": "[北京市] 快件到达 [北京]",
                     "time": "2017-06-15 23:02:03"
                     },
                     {
                     "name": "[北京市] 快件离开 [北京市内部]已发往[北京昌平二部中通]",
                     "time": "2017-06-16 03:00:00"
                     },
                     {
                     "name": "[北京市] 快件已到达[北京昌平二部中通],业务员王绪恒正在第1次派件 电话:18210113218 请保持电话畅通、耐心等待",
                     "time": "2017-06-16 07:17:14"
                     },
                     {
                     "name": "[北京市] [北京昌平二部中通]的派件已签收 感谢使用中通快递,期待再次为您服务!",
                     "time": "2017-06-16 13:48:12"
                     }*/
                ]
            }
        },
        created: function () {
            this.getTraceInfo();
        },
        methods: {
            getTraceInfo: function () {
                // logisComCode = 'ZTO';
                let self = this;
                let postData = {};
                postData.expNo = self.logisExpNo;   // '536955967199';
                postData.comCode = self.logisComCode;   //"ZTO";
                postData.realTime = true; // 实时查询，（目前）默认为true
                //
                let msgBoxDlg = MsgBox.loading();
                logisApi.getTraceInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        /*console.log('物流信息......');
                         console.log(result);*/
                        //
                        self.logisTraceData = result.data;
                        self.loading = false;
                    } else {
                        MsgBox.warning('暂不支持物流查询');
//                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>






// WEBPACK FOOTER //
// src/compo/order/LogisTraceInfo.vue